<script setup lang="ts">
import { EventItem } from '/@utilities/registrations';

defineProps<{
  eventItem: EventItem;
  small?: boolean;
}>();
</script>

<template>
  <router-link
    class="event card"
    :class="{
      'event-small': small,
      '-time': eventItem.isTime,
      '-label': eventItem.isLabel,
      '-day': eventItem.isDay,
      '-expense': eventItem.isExpense,
      '-correction': eventItem.correction,
    }"
    v-on:click="$emit('event-click', eventItem)"
    :to="`/timer/${small ? 'week' : 'day'}/${eventItem.id}`"
  >
    <div class="event-count badge">
      {{ eventItem.count }}
    </div>

    <div
      class="event-indicators"
      :class="{ 'event-indicators-small': small }"
      v-if="eventItem.approved || eventItem.notesCount"
    >
      <df-icon v-if="eventItem.approved" code="f058" />
      <df-icon v-else-if="eventItem.notesCount" code="f27a" />
    </div>

    <div class="event-article" :class="{ 'event-article-small': small }">
      {{ eventItem.name }}
    </div>

    <div class="event-project text-small" :class="{ 'event-project-small': small }">
      {{ eventItem.project }}
    </div>
  </router-link>
</template>

<style scoped>
.event {
  display: grid;
  gap: 0 var(--gap-md);
  color: white;
  background-color: var(--color-event);
  grid-template-areas: 'badge article' 'badge project';
  grid-template-columns: max-content 1fr;
  align-items: center;
  position: relative;
  border: none;
  text-align: left;
  text-decoration: none;

  &:hover {
    background-image: linear-gradient(#0003, #0003);
  }
}

.event-small {
  display: flex;
  flex-direction: column;
  gap: var((--gap-sm));
  overflow: hidden;
  text-align: center;
}

.event-count {
  grid-area: badge;
}

.event-article {
  grid-area: article;
  word-break: break-word;
}

.event-article-small {
  font-size: 0.8rem;
}

.event-project {
  grid-area: project;
}

.event-project-small {
  display: none;
}

.event-indicators {
  position: absolute;
  top: var(--gap-md);
  right: var(--gap-md);
  opacity: 0.5;
}

.event-indicators-small {
  position: static;
  font-size: 0.8rem;
}

@media (max-width: 900px) {
  .event-article-small {
    font-size: 0.7rem;
  }
}
</style>
